import { FileExclamationTwoTone, FileTextOutlined, LoadingOutlined } from "@ant-design/icons";
import { Box, HStack, VStack } from "@chakra-ui/react";
import { Button, Input, Select, Typography } from "antd";
import { PropsWithChildren, useState } from "react";

const { Text } = Typography;
const { Option } = Select;
const { Search } = Input;

export const DefaultDays = 0;

interface TableActionsProps {
    onDaysChanged: (value: number) => void;
    onFilterChanged?: (value: string) => void;
    isLoading: boolean;
    filterPlaceholder?: string;
    showFilter?: boolean;
    onExportCSV?: () => Promise<void>;
    allowExport?: boolean;
}

const TableActions = ({
    onDaysChanged,
    onFilterChanged = (_) => { },
    isLoading,
    filterPlaceholder = "Search",
    showFilter = true,
    onExportCSV,
    allowExport = true,
    children
}: TableActionsProps & PropsWithChildren) => {
    const [exporting, setExporting] = useState(false);

    const exportCsv = async () => {
        setExporting(true);

        try {
            if (onExportCSV) {
                await onExportCSV();
            }
        } finally {
            setExporting(false);
        }
    }

    return (
        <VStack align="right">
            <HStack justifyContent="flex-end">
                {children}
                {allowExport ? (
                    <Button onClick={exportCsv} type="link" disabled={exporting}>
                        {exporting ? (
                            <span style={{ color: 'var(--dcs-light-blue)' }}><LoadingOutlined /> Exporting to CSV...</span>
                        ) : (
                            <><FileTextOutlined /> Export to CSV</>
                        )}
                    </Button>
                ) : (
                    <Box textColor="var(--dcs-gray)">
                        <FileExclamationTwoTone twoToneColor="#eb2f96" /> Export to CSV
                    </Box>
                )}
            </HStack>
            <HStack justifyContent="end">
                <Text style={{ color: "var(--dcs-white)" }}>Date Range:</Text>
                <Select
                    placeholder="Date Range"
                    defaultValue={DefaultDays}
                    onChange={onDaysChanged}
                >
                    <Option value={0}>No Date Limit</Option>
                    <Option value={90}>Last 90 Days</Option>
                    <Option value={60}>Last 60 Days</Option>
                    <Option value={30}>Last 30 Days</Option>
                </Select>
                {showFilter === true && (
                    <Search
                        loading={isLoading}
                        placeholder={filterPlaceholder}
                        onSearch={onFilterChanged}
                        allowClear
                    />
                )}
            </HStack>
        </VStack>
    );
};

export default TableActions;